import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../models/list-result';
import { ModuleSubmissionAdminRead } from '../models/module-submission-admin-read.model';
import { ModuleSubmissionReview } from '../models/module-submission-review.model';
import { DataService } from './abstract-services/data.service';

@Injectable()
export class ModuleSubmissionAdminService extends DataService<ModuleSubmissionAdminRead> {
    apiUrl = 'module_manager/v1/admin/modulesubmissions';

    constructor(protected http: HttpClient) {
        super();
    }

    review(submissionId: string, moduleReview: ModuleSubmissionReview): Observable<Object> {
        return this.http.patch(`${this.endpoint}/${submissionId}`, moduleReview);
    }

    async getList(): Promise<ListResult<ModuleSubmissionAdminRead>> {
        const params = new HttpParams().set('page[number]', '1').set('page[size]', '100');

        return super.getList(params);
    }

    protected createNewInstance(): ModuleSubmissionAdminRead {
        return new ModuleSubmissionAdminRead();
    }
}
